// TODO: maybe move this to a shared lib?
export const concatPhone = (code?: string, phone?: string) => {
	if (code && phone) {
		return `+${code} ${phone}`;
	}
	return null;
};
